import ApiCore from './utilities/core'
import apiProvider from './utilities/provider'

const url = 'reference-contacts'

const apiReferenceContacts = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: true,
  patch: true,
  delete: false,
  url,
})

apiReferenceContacts.submitContacts = (token, data) =>
  apiProvider.post(`${url}/request/${token}`, data)

export default apiReferenceContacts
